const homeRoutes = {
	name: 'app.home',
	meta: { requiresAuth: true, showTopbar: true },
	redirect: { name: 'Dashboard' },
	component: () => import('#modules/home/HomeModule.vue'),
	children: [
		{
			name: 'Dashboard',
			path: '/',
			component: () => import('#modules/home/pages/DashboardPage.vue'),
		},
	],
}

export default homeRoutes
